import * as React from "react";
import "./CPHrBreakStyles.scss";

interface CPHrBreakProps {
  /** Shorthand to set equal top and bottom margin in pixels. Overridden per-side by `marginTop` / `marginBottom`. */
  spacing?: number;
  /** Top margin in pixels. Takes precedence over `spacing` for the top side. */
  marginTop?: number;
  /** Bottom margin in pixels. Takes precedence over `spacing` for the bottom side. */
  marginBottom?: number;
}

/**
 * Horizontal rule divider with configurable vertical spacing.
 *
 * @example
 * ```tsx
 * <CPHrBreak spacing={16} />
 *
 * // Separate top and bottom margins
 * <CPHrBreak marginTop={8} marginBottom={24} />
 * ```
 */
const CPHrBreak: React.FC<CPHrBreakProps> = (props) => {
  return (
    <div
      className="cp-hr-line-break"
      style={{
        marginTop: props.marginTop ?? props.spacing,
        marginBottom: props.marginBottom ?? props.spacing,
      }}
    ></div>
  );
};

export default CPHrBreak;
